import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=b84785e4&scoped=true&"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js&"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeScanner.vue?vue&type=style&index=0&id=b84785e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84785e4",
  null
  
)

export default component.exports